import { useEffect, useRef, useState } from 'react'

import {
  AD_REFRESH_COOLDOWN_LEGACY,
  GPT_COMPONENT_ID,
} from '@/features/advertisement/constants/adSlots'
import { triggerManualAdRefresh } from '@/features/advertisement/utils/triggerManualAdRefresh'

const SCROLL_AWAY_TRIGGER_DISTANCE = 800

export const useScrollAway = () => {
  const [scrollAway, setShouldScrollAway] = useState(false)
  const [isSticky, setIsSticky] = useState(false)

  const shouldTopLeaderboardRefresh = useRef<boolean>(false)
  const recentlyRefreshed = useRef<boolean>(false)

  const setRefreshTimer = () => {
    recentlyRefreshed.current = true
    return setTimeout(() => {
      recentlyRefreshed.current = false
    }, AD_REFRESH_COOLDOWN_LEGACY)
  }

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY >= SCROLL_AWAY_TRIGGER_DISTANCE) {
        setShouldScrollAway(true)
      } else {
        setShouldScrollAway(false)
      }
    }

    window.addEventListener('scroll', checkScroll)

    return () => {
      window.removeEventListener('scroll', checkScroll)
    }
  }, [])

  const handleInViewChange = (inView: boolean) => {
    setIsSticky(!inView)

    // refresh top leaderboard when user scrolls down past it and then back up to the top
    if (shouldTopLeaderboardRefresh.current && !recentlyRefreshed.current && inView) {
      shouldTopLeaderboardRefresh.current = false
      triggerManualAdRefresh(GPT_COMPONENT_ID.TOP_LEADERBOARD)
      setRefreshTimer()
    } else {
      shouldTopLeaderboardRefresh.current = true
    }
  }

  return { isSticky, scrollAway, handleInViewChange }
}
